import React from 'react';
import PropTypes from 'prop-types';

function Headline({ children, description = undefined }) {
  return (
    <div className="headline">
      <div className="main">{children}</div>
      <div className="description">{description}</div>
    </div>
  );
}

Headline.propTypes = {
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Headline;
